import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M6 5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm0 5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zm0 5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zm5-10a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2q.089 0 .173-.015l.058-.139c.19-.458.456-.826.769-1.11V6a1 1 0 0 0-1-1zm1.75 5H11a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.083zm-2.1 5.063A1 1 0 0 0 10 16v2a1 1 0 0 0 1 1h2q.093 0 .18-.016c-1.886-.196-3.133-2.106-2.53-3.92M16 17h-2.5a1 1 0 0 1-.923-1.384l2.5-6c.387-.93 1.694-.748 1.897.142Q17 9.872 17 10v3h2.5a1 1 0 0 1 .923 1.385l-2.5 6C17.503 21.394 16 21.093 16 20zm2.722-8.309C18.07 7.287 16.388 6.686 15 7.151V6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-.278.691"
    }
  )
);
var SvgPowerDialerFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PowerDialerFilled_default = SvgPowerDialerFilled;

export { PowerDialerFilled_default as default };
